import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {    
   'en': {
           Customer: 'Customer' ,
           Month:'of this Month',
           Total:'Total',
           Sales:'Sales',
           Today:'Today',
           Expense:'Expense',
           Options:'Options',
           Customer_review:'Customer Review',
           Published_feature:'Published Feature',
           Products:'Products',
           Products_category:'Total Category Types',
           Total_items:'Total Items',
           Orders:'Orders',
           Pending:'Pending',
           Processing:'Processing',
           Deliveries:'Deliveries',
           of:'of',
           POS:'POS',
           Total_orders:'Total Orders',
           New:'New',
           Complete:'Complete',
           Cancelled:'Cancelled',
           Business_report:'Business Reports',
           Tax:'Tax',
           Income_expense:'Income Expense Comparison Of',
           Net_earning:'Net Earnings After Tax',
           This_week:'This Week',
           Report:'Report',
           Weekly:'Weekly',
           Customer_name:'Customer Name',
           Email:'Email',
           Phone:'Phone',
           Company:'Company',
           Designation:'Designation',
           Created:'Created',
           Action:'Action',
           Search_customer:'Search Customer',
           Rows_per_page: 'Rows Per Page',
           Country:'Country',
           City:'City',
           Details:'Details',
           Address:'Address',
           Purchase_history:'Purchase History',
           Search_by_id:'Search By Order ID',
           Sales_date:'Sales Date',
           Order_id:'Order ID',
           Sales_type:'Sales Type',
           Number_items:'Number of Items',
           Total_price:'Total Price',
           Check_all:'Check All',
           Search_expense:'Search Expense',
           Expense_title:'Expense Title',
           Expense_amount:'Expense Amount',
           Expense_type:'Expense Type',
           Add:'Add',
           Update:'Update',
           Administration:'Administration',
           Fees:'Fees',
           Purchase:'Purchase',
           Cost:'Cost',
           Employee:'Employee',
           Food:'Food',
           Entertainment:'Entertainment',
           Travel:'Travel',
           Marketing:'Marketing & Advertising',
           Good_sold:'Goods Sold',
           January:'January',
           February:'February',
           March:'March',
           April:'April',
           May:'May',
           June:'June',
           July:'July',
           August:'August',
           September:'September',
           October:'October',
           November:'November',
           December:'December',
           Search_items:'Search Items',
           Image:'Image',
           Item_name:'Item Name',
           Price_per_unit:'Price (Per Unit)',
           Featured:'Featured',
           Category:'Category',
           Upload:'Upload',
           Item:'Item',
           Search_category:'Search Category',
           Quantity:'Quantity',
           Looking_for:'What items you are looking for?',
           Mobile_number:'Mobile No.',
           Vat:'VAT',
           Include:'Include',
           Place_order:'Place Order',
           Bag_empty:'Your shopping bag is empty!',
           Not_included:'VAT Not Included',
           Date:'Date',
           Thank_u:'Thank You',
           Come_again:'Please Come Again',
           Checkout_print:'Checkout with Print',
           Price:'Price',
           Add_cart:'Add to Cart',
           Return_to:'Return to POS',
           Search_orders:'Search Orders',
           Order_date:'Order Date & Time',
           Order_status:'Order Status',
           Search_deliveries:'Search Deliveries',
           Delivery:'Delivery',
           Person:'Person',
           Name:'Name',
           Time:'Time',
           This_order:'This order',
           Print:'Print',
           Cart:'Cart',
           Search_project:'Search Projects',
           Grand:'Grand',
           Project_name:'Project Name',
           Current:'Current',
           Project:'Project',
           Start_date:'Start Date',
           Deadline:'Deadline',
           Project_details:'Project Details...',
           Budget:'Budget',
           Estimated_hour:'Estimated Hour',
           Delivery_person:'Delivery Person',
           Search_delivery_person:'Search Delivery Person',
           Logo:'Logo',
           Slider:'Slider',
           Title:'Title',
           Subtitle:'Sub Title',
           Feature:'Feature',
           Icon:'Icon',
           Text:'Text',
           Review:'Review',
           Guest_name:'Guest Name',
           Support_title:'Support Title',
           Sent:'Sent At',
           Enter_message:'Enter Message',
           Session_expired:'Your Session expired !!',
           Start_new:'Start New Session',
           Live_chat:'Live Chat',
           Subject:'What type of support you are looking for?',
           Start_chat:'Start Chat',
           Password:'Password',
           Currency:'Currency',
           Rate:'Rate',
           Shipping:'Shipping',
           About_page:'About Page',
           Security_pin:'Security PIN',
           New_password:'New Password',
           Company_name:'Company Name',
           Company_address:'Company Address',
           Company_mobile:'Company Mobile',
           Dashboard:'Dashboard',
           Categories:'Categories',
           Check:'Check Our',
           Delicious:'Delicious Menu',
           Foods:'Foods',
           History:'A history of',
           Proceed:'Proceed to',
           Your:'Your',
           Received:'Your order has been received',
           Sign_in:'Sign In',
           Dont_have_account:'Donot have any account yet ?',
           Create_account:'Create Account',
           Account:'Account',
           Edit:'Edit',
           Histo:'History',
           My:'My',
           Settings:'Settings',
           Flat_no:'Flat Number',
           Building_no:'Building Number',
           Order:'Order',
           Remove:'Remove',
           Successful:'Successful',
           Customers:'Customers',
           Sales_report:'Sales Report',
           Reviews:'Reviews',
           Features:'Features',
           Recent_deliveries:'Recent Deliveries',
           Delivery_list:'Delivery List',
           Expenses:'Expenses',
           Expense_report:'Expense Report',
           Home:'Home',
           About:'About',
           Menu:'Menu',
           Logout:'Logout',
           Support:'Support',
           Select_person:'Select Person',
           Status:'Status',
           Subtotal:'Sub Total',
           Checkout:'Checkout',
           Items:'Items',
           
            
           
            
           
           
           
           
          
           

         
         
         
         },   
   'pt': {      
            Customer: 'Cliente' ,
            Month:'este Mes',
            Total:'Total',
            Sales:'Vendas',
            Today:'Hoje',
            Expense:'Despesa',
            Options:'Opções',
            Customer_review:'Revisão do cliente',
            Published_feature:'Recurso Publicado',
            Products:'Produtos',
            Products_category:'Total de Tipos de Categoria',
            Total_items:'Total de Itens',
            Orders:'Encomenda',
            Pending:'Pendentes',
            Processing:'Processamento',
            Deliveries:'Entregas',
            of:'do',
            POS:'POS',
            New:'Novo',
            Complete:'Completo',
            Cancelled:'Cancelado',
            Business_report:'Relatório de Negócios',
            Tax:'Imposto',
            Income_expense:'Comparação de Despesas de Receita de',
            Net_earning:'Lucro Líquido após Impostos',
            This_week:'esta Semana',
            Weekly:'Semanal',
            Report:'Relatório',
            Customer_name:'Nome de Cliente',
            Email:' El Email',
            Phone:'Teléfono',
            Company:'Companhia',
            Designation:'Designaçãon',
            Created:'Criado',
            Action:'Açao',
            Search_customer:'Pesquisar Cliente',
            Rows_per_page: 'Filas por Página',
            Country:'País',
            City:'Cidade',
            Details:'Detallhes',
            Address:'Endereço',
            Purchase_history:'Histórico de Compras',
            Search_by_id:'Pesquisar por ID do Pedido',
            Sales_date:'Data de vendas',
            Order_id:'Ordem ID',
            Sales_type:'Tipo de vendas',
            Number_items:'Número de ítens',
            Total_price:'Preço total',
            Check_all:'Verifique Tudo',
            Search_expense:'Despesa de Pesquisa',
            Expense_title:'Título da despesa',
            Expense_amount:'Montante da despesa',
            Expense_type:'Tipo de Despesa',
            Add:'Adicionar',
            Update:'Atualizar',
            Administration:'Administração',
            Fees:'Honorários',
            Purchase:'Compra',
            Cost:'Custo',
            Employee:'Empregado',
            Food:'Comida e',
            Entertainment:'Entretenimento',
            Travel:'Viagem Custo',
            Marketing:'Marketing e Publicidade',
            Good_sold:'Bens Vendidos',
            January:'Janeiro',
            February:'Fevereiro',
            March:'Março',
            April:'Abril',
            May:'Maio',
            June:'Junho',
            July:'Julho',
            August:'Agosto',
            September:'Setembro',
            October:'Outubro',
            November:'Novembro',
            December:'Dezembro',
            Search_items:'itens de pesquisa',
            Image:'Imagem',
            Item_name:'Nome do item',
            Price_per_unit:'Preço (Por Uni)',
            Featured:'Destaque',
            Category:'Categoria',
            Upload:'Envio',
            Item:'Item',
            Search_category:'Categoria de Pesquisa',
            Quantity:'Quantidade',
            Looking_for:'Qual itens você está procurando?',
            Mobile_number:'Número de celular',
            Vat:'IVA',
            Include:'Inclui',
            Place_order:'Faça a Encomenda',
            Bag_empty:'O seu saco de compras está vazio !',
            Not_included:'IVA Não Incluído',
            Date:'Data',
            Thank_u:'Obrigado',
            Come_again:'Por favor volte',
            Checkout_print:'Checkout com impressão',
            Price:'Preço',
            Add_cart:'Adicionar ao carrinho',
            Return_to:'Retornar ao POS',
            Search_orders:'Pesquisar pedidos',
            Order_date:'Data e hora do pedido',
            Order_status:'Status do pedido',
            Search_deliveries:'Pesquisar Entregas',
            Delivery:'Entrega',
            Person:'Pessoa',
            Name:'Nome',
            Time:'Tempo',
            This_order:'Esta ordem ',
            Print:'Impressão',
            Cart:'Carrinho',
            Grand:'Grande',
            Search_project:'Pesquisa Projeto',
            Project_name:'Nome do Projeto',
            Current:'Atual',
            Project:'Projeto',
            Start_date:'Data de Início',
            Deadline:'Data limite',
            Project_details:'Projeto Detalhes...',
            Budget:'Despesas',
            Estamated_hour:'Hora Estimada',
            Delivery_person:'Entrega Pessoa',
            Search_delivery_person:'Pesquisa Entrega Pessoa',
            Logo:'Logotipo',
            Slider:'Controles Deslizantes',
            Title:'Título',
            Subtitle:'Sub Título',
            Feature:'Característico',
            Icon:'Ícone',
            Text:'Texto',
            Review:'Rever',
            Guest_name:'Nome do convidado',
            Support_title:'Título do Suporte',
            Sent:'Enviado às',
            Enter_message:'Inserir Mensagem',
            Session_expired:'Sua Sessão Expirou',
            Start_new:'Iniciar Nova Sessão',
            Live_chat:'Bate-papo ao vivo',
            Subject:'Que tipo de suporte você está procurando',
            Start_chat:'Iniciar bate-papo',
            Password:'Senha',
            Currency:'Moeda',
            Rate:'Taxa',
            Shipping:'Expedição',
            About_page:'Sobre a página',
            Security_pin:'PIN de segurança',
            New_password:'Nova Senha',
            Company_name:'Nome da empresa',
            Company_address:'Endereço da companhia',
            Company_mobile:'Número de celular da empresa',
            Dashboard:'Painel de Controle',
            Categories:'Categorias',
            Check:'Confira Nosso ',
            Delicious:'Menu Delicioso',
            Foods:'Alimentos',
            History:'Uma história de',
            Proceed:'Continuar o',
            Your:'Seu',
            Received:'Seu pedido foi recebido',
            Sign_in:'Assinar em',
            Dont_have_account:'Ainda não tem uma conta?',
            Create_account:'Criar Conta',
            Account:'Conta',
            Edit:'Editar',
            Histo:'Historia',
            My:'Meu',
            Settings:'Definições',
            Flat_no:'Número do apartamento',
            Building_no:'Número do edifício',
            Order:'Ordem',
            Remove:'Retirar',
            Successful:'bem-sucedido',
            Customers:'Clientes',
            Sales_report:'Relatório de Vendas',
            Reviews:'Rever',
            Features:'Recursos',
            Recent_deliveries:'Entregas Recentes',
            Delivery_list:'Lista de entrega',
            Expenses:'Despesas',
            Expense_report:'Relatório de Despesas',
            Home:'CASA',
            About:'SOBRE',
            Logout:'Sair',
            Support:'Suporte',
            Select_person:'Selecionar Pessoa',
            Status:'Status',
            Subtotal:'Sub Total',
            Checkout:'Checkout',
            Items:'Items',
            
            
            
            

         

         
         
            },



            'tr':{

               Customer: 'Müşteri' ,
           Month:'bu Ayın',
           Total:'Toplam',
           Sales:'Satış',
           Today:'Bugün',
           Expense:'Gider',
           Options:'Seçenekler',
           Customer_review:'Müşteri yorumu',
           Published_feature:'Yayınlanmış Özellik',
           Products:'Urünler',
           Products_category:'Toplam Kategori Türleri',
           Total_items:'Tüm nesneler',
           Orders:'Siparişler',
           Pending:'Bekliyor',
           Processing:'Işleme',
           Deliveries:'Teslimatlar',
           of:'nın-nin',
           POS:'POS',
           Total_orders:'Toplam Sipariş',
           New:'Yeni',
           Complete:'Tamamlayınız',
           Cancelled:'İptal edildi',
           Business_report:'Faaliyet Raporları',
           Tax:'Vergi',
           Income_expense:'Gelir Gider Karşılaştırma',
           Net_earning:'Vergi Sonrası Net Kazanç',
           This_week:'Bu hafta',
           Report:'Rapor',
           Weekly:'Haftalık',
           Customer_name:'Müşteri adı',
           Email:'Email',
           Phone:'Telefon',
           Company:'şirket',
           Designation:'Tayin',
           Created:'düzenlendi',
           Action:'Aksiyon',
           Search_customer:'Müşteri Ara',
           Rows_per_page: 'Sayfa Başına Satır',
           Country:'ülke',
           City:'Kent',
           Details:'Ayrıntılar',
           Address:'Adres',
           Purchase_history:'Satın alım geçmişi',
           Search_by_id:'Sipariş Kimliğine Göre Ara',
           Sales_date:'Satış Tarihi',
           Order_id:'Sipariş Kimliği',
           Sales_type:'Satış Tipi',
           Number_items:'Ürün Sayısı',
           Total_price:'Toplam fiyat',
           Check_all:'Tümünü Kontrol Et',
           Search_expense:'Arama Gideri',
           Expense_title:'Gider Başlığı',
           Expense_amount:'Gider Tutarı',
           Expense_type:'Gider Türü',
           Add:'Ekle',
           Update:'Güncelleme',
           Administration:'yönetim',
           Fees:'harç',
           Purchase:'Mübayaa',
           Cost:'Masraf',
           Employee:'Işçi',
           Food:'Gıda',
           Entertainment:'Eğlence',
           Travel:'Seyahat',
           Marketing:'Pazarlama reklamı',
           Good_sold:'Satılan Ürünler',
           January:'Ocak',
           February:'Şubat',
           March:'Mart',
           April:'Nisan',
           May:'Mayıs',
           June:'Haziran',
           July:'Temmuz',
           August:'Ağustos',
           September:'Eylül',
           October:'Ekim',
           November:'Kasım',
           December:'Aralık',
           Search_items:'Öğelerde Ara',
           Image:'Görüntü',
           Item_name:'Öğe adı',
           Price_per_unit:'Fiyat (Birim Başına)',
           Featured:'Öne çıkan',
           Category:'Kategori',
           Upload:'Yükleme',
           Item:'Madde',
           Search_category:'Arama Kategorisi',
           Quantity:'Miktar',
           Looking_for:'Hangi öğeleri arıyorsunuz?',
           Mobile_number:'Telefon numarası.',
           Vat:'KDV',
           Include:'Dahil etmek',
           Place_order:'Sipariş Vermek',
           Bag_empty:'Alışveriş çantanız boş!',
           Not_included:'KDV dahil değildir',
           Date:'tarih',
           Thank_u:'Teşekkür ederim',
           Come_again:'Lütfen tekrar gelin',
           Checkout_print:'Print ile ödeme',
           Price:'Fiyat',
           Add_cart:'Sepete ekle',
           Return_to:'Geri vermek POS',
           Search_orders:'Siparişleri ara',
           Order_date:'Sipariş Tarihi ve Saati',
           Order_status:'Sipariş durumu',
           Search_deliveries:'Teslimatlarda Ara',
           Delivery:'Teslim',
           Person:'Kişi',
           Name:'Isim',
           Time:'Zaman',
           This_order:'Bu sipariş',
           Print:'Baskı',
           Cart:'Araba',
           Search_project:'Projelerde Ara',
           Grand:'Ulu',
           Project_name:'Proje Adı',
           Current:'Simdiki',
           Project:'Proje',
           Start_date:'Başlangıç ​​tarihi',
           Deadline:'Son tarih',
           Project_details:'Proje detayları...',
           Budget:'Bütçe',
           Estimated_hour:'Tahmini Saat',
           Delivery_person:'Teslimatçı',
           Search_delivery_person:'Teslimatçı Ara',
           Logo:'Logo',
           Slider:'Kaydırıcı',
           Title:'Başlık',
           Subtitle:'Alt yazı',
           Feature:'özellik',
           Icon:'Ikon',
           Text:'Metin',
           Review:'gözden geçirmek',
           Guest_name:'Misafir adı',
           Support_title:'Destek Başlığı',
           Sent:'Gönderildiği yer',
           Enter_message:'Mesaj Girin',
           Session_expired:'Oturumunuzun süresi doldu !',
           Start_new:'Yeni Oturum Başlat',
           Live_chat:'Canlı sohbet',
           Subject:'Ne tür bir destek arıyorsunuz?',
           Start_chat:'Sohbeti Başlat',
           Password:'Parola',
           Currency:'Para birimi',
           Rate:'Oran',
           Shipping:'Nakliye',
           About_page:'Sayfa Hakkında',
           Security_pin:'Güvenlik Kodu',
           New_password:'Yeni Şifre',
           Company_name:'Şirket Adı',
           Company_address:'Sirket Adresi',
           Company_mobile:'Şirket Mobil',
           Dashboard:'kontrol paneli',
           Categories:'Kategoriler',
           Check:'Kontrol Edin',
           Delicious:'Lezzetli Menü',
           Foods:'Gıdalar',
           History:'Tarihçesi',
           Proceed:'Devam',
           Your:'Sizin',
           Received:'Siparişiniz alındı',
           Sign_in:'Oturum aç',
           Dont_have_account:'Henüz hesabınız yok mu?',
           Create_account:'Hesap oluştur',
           Account:'Hesabi',
           Edit:'Düzenle',
           Histo:'Tarih',
           My:'Benim',
           Settings:'Ayarlar',
           Flat_no:'Daire numarası',
           Building_no:'Bina numarası',
           Order:'Sipariş',
           Remove:'Kaldırmak',
           Successful:'Başarılı',
           Customers:'Müşteriler',
           Sales_report:'Satış Raporu',
           Reviews:'Yorumlar',
           Features:'Özellikleri',
           Recent_deliveries:'Son Teslimatlar',
           Delivery_list:'Teslimat Listesi',
           Expenses:'Giderler',
           Expense_report:'Gider Raporu',
           Home:'Ev',
           About:'Hakkinda',
           Menu:'Menu',
           Logout:'çıkış Yap',
           Support:'Destek',
           Select_person:'Kişi Seçin',
           Status:'Durum',
           Subtotal:'Ara Toplam',
           Checkout:'Ödeme',
           Items:'Öğeler',

            }




                    
         };
export  const i18n= new VueI18n({    locale: 'en',    fallbackLocale: 'en',     messages, silentTranslationWarn: true});



// WEBPACK FOOTER //
// ./src/plugins/i18n.js